<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    @if (canCreate) {
      <button type="button" class="btn btn-primary" (click)="openCreateModal()">Ajouter une instruction RSJ</button>
    }
  </div>

  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="instructionsTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="instructionDate" (sort)="onSort($event)">Date de l'instruction</th>
            <th scope="col" class="text-center" sortable="directedBy" (sort)="onSort($event)">Réalisée par</th>
            <th scope="col" class="text-center" sortable="referentName" (sort)="onSort($event)">Référent</th>
            <th scope="col" class="text-center" sortable="structureLabel" (sort)="onSort($event)">Structure</th>
            <th scope="col" class="text-center" sortable="status" (sort)="onSort($event)">État</th>
            <th scope="col" class="text-center d-none">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (instructionRSJ of instructionsRSJ.items; track instructionRSJ) {
            <tr>
              <td (click)="openConsultModal(instructionRSJ.id)"></td>
              <td (click)="openConsultModal(instructionRSJ.id)" class="text-center">
                {{ instructionRSJ.instructionDate | date }}
              </td>
              <td (click)="openConsultModal(instructionRSJ.id)" class="text-center">
                {{ instructionRSJ.directedBy }}
              </td>
              <td (click)="openConsultModal(instructionRSJ.id)" class="text-center">
                {{ instructionRSJ.referent }}
              </td>
              <td (click)="openConsultModal(instructionRSJ.id)" class="text-center">
                {{ instructionRSJ.structure }}
              </td>
              <td (click)="openConsultModal(instructionRSJ.id)" class="text-center">
                {{ instructionRSJ.status }}
              </td>
              <td class="text-center d-none">
                <button
                  placement="left"
                  ngbTooltip="Dupliquer l'instruction"
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="openConsultModal(instructionRSJ.id)"
                  >
                  <fa-icon class="d-block" icon="clone"></fa-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (instructionsRSJ.items.length === 0) {
        <p>Le bénéficiaire n'a aucune instruction RSJ.</p>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="instructionsRSJ.totalItems"
      [page]="instructionsRSJ.options.page"
      [pageSize]="instructionsRSJ.options.limit"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="instructionsRSJ.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
